import {
    createVNode as _$cv,
    className as _$cn,
} from 'intact';
import {addStyle, getRestProps} from '../utils';
import makeStyles from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {className, style, size, color, rotate, hoverable, children} = this.get();
    
    const classNameObj = {
        'k-icon': true,
        'k-rotate': rotate,
        'k-hoverable': hoverable,
        [className]: className,
    };
    const _style = {};
    if (/^\d+$/.test(size)) {
        _style.fontSize = size + 'px'; 
    } else if (size !== 'default') {
        classNameObj[`k-${size}`] = true;
    }
    if (this.colors.indexOf(color) > -1) {
        classNameObj[`k-${color}`] = color !== 'default';
        classNameObj[makeStyles()] = true;
    } else if (color) {
        _style.color = color;
        classNameObj[makeStyles(color)] = true;
    } else {
        classNameObj[makeStyles()] = true;
    }
    
    return _$cv('i', {
        'className': _$cn(classNameObj),
        'style': addStyle(style, _style),
        ...getRestProps(this)
    }, children);
};